import * as React from "react"

import * as moment from 'moment';
import { HomeQuery, query, variables, QueryResult } from "../../../api/queries/home";
import { getClient } from '../../../api/graphql'
import { ApolloProvider } from "react-apollo";

import { PageLoader } from "../../shared/loaders/PageLoader";
import { Index, HomeRoutes, HomeAssets } from "../../home/Index";
import * as Routes from "../../../api/routes";
import * as Assets from "../../../api/assets";
import { StartEnd } from "../../../utils/period_picker/PeriodPicker";
import { FocusedInputShape } from "react-dates";
import QuickFilterSubmit from "../../../api/quick_filter/submit";

import * as Cookie from 'js-cookie'
import { HasCookiesConsent } from "../../../utils/cookie_consent";
import { QuickFilterProps } from "../../home/components/QuickFilter";

type Props = StartEnd & {
  data: QueryResult
}

type State = StartEnd & {
  focusedInput: FocusedInputShape
  mobileFocusedInput: FocusedInputShape
  readMoreOpen: boolean
  maxPeople: number
  filterDisabled: boolean
  showFacebookPagePlugin: boolean
}

class StatefullShowPageContainer extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props)
    this.state = {
      startDate: this.props.startDate ? moment(this.props.startDate, "DD-MM-YYYY") : null,
      endDate: this.props.endDate ? moment(this.props.endDate, "DD-MM-YYYY") : null,
      focusedInput: null,
      mobileFocusedInput: null,
      readMoreOpen: false,
      maxPeople: 0,
      filterDisabled: false,
      showFacebookPagePlugin: false,
    }
  }
  componentDidMount() {
    window.addEventListener('scroll', () => {
      if (window.scrollY / document.body.offsetHeight > 0.75) {
        this.setState({showFacebookPagePlugin: true})
      }
    })
  }

  onFilterSubmit() {
    this.setState({filterDisabled: true}, async () => {
      await QuickFilterSubmit(this.state.startDate, this.state.endDate, this.state.maxPeople)
      this.setState({filterDisabled: false})
    })
  }

  onFacebookClose() {
    Cookie.set('fbpopup_dismissed', 'true', { expires: 30 })
    this.setState({showFacebookPagePlugin: false})
  }

  render() {

    const filterProps : QuickFilterProps = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      maxPeople: this.state.maxPeople,
      filterDisabled: this.state.filterDisabled,
      onMaxPeopleChange: (i) => this.setState({maxPeople: i}),
      focusedInput: this.state.focusedInput,
      onFocusChange: (fi) => this.setState({ focusedInput: fi}),
      onDatesChange: (range: StartEnd) => this.setState({...range}),
      onFilterSubmit: () => this.onFilterSubmit(),
    }

    const mobileFilterProps : QuickFilterProps = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      maxPeople: this.state.maxPeople,
      filterDisabled: this.state.filterDisabled,
      onMaxPeopleChange: (i) => this.setState({maxPeople: i}),
      focusedInput: this.state.mobileFocusedInput,
      onFocusChange: (fi) => this.setState({ mobileFocusedInput: fi}),
      onDatesChange: (range: StartEnd) => this.setState({...range}),
      onFilterSubmit: () => this.onFilterSubmit(),
    }

    return (
      <Index
        routes={Routes.ToDictionary<HomeRoutes>(this.props.data.routes)}
        headerImage={this.props.data.siteSettings.homepageImage}
        assets={Assets.ToDictionary<HomeAssets>(this.props.data.assets)}
        highlightAdverts={this.props.data.highlighted_adverts}
        highlightAreas={this.props.data.highlighted_areas}
        highlightThemes={this.props.data.highlighted_themes}
        contentAboveCarousel={this.props.data.siteSettings.contentAboveCarousel}
        readMoreOpen={this.state.readMoreOpen}
        toggleReadMore={(b) => this.setState({readMoreOpen: b})}
        showFacebookPagePlugin={HasCookiesConsent() && this.state.showFacebookPagePlugin && !Cookie.get('fbpopup_dismissed')}
        onFacebookClose={() => this.onFacebookClose()}
        filter={filterProps}
        mobileFilter={mobileFilterProps}
      />
    )
  }
}


export default (props: StartEnd) : JSX.Element => (
  <ApolloProvider client={getClient()}>
    <HomeQuery
      query={query()}
      variables={variables()}
    >
      {({ loading, error, data}) => {
        if(loading) return <PageLoader />
        if(error) return <div>Something went wrong</div>
        return (
          <StatefullShowPageContainer
            startDate={props.startDate}
            endDate={props.endDate}
            data={data}
          />
        )
      }}
    </HomeQuery>
  </ApolloProvider>
)
